import React, { useEffect, useRef, useState } from 'react';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import {
  kmzNetwork,
  leasingPoints,
  noNetwork,
  openRouteNamePopUp,
  routeSelection,
  selectedRoutePath,
} from '../../common/atom/atoms.js';
import { getPaginationRange } from '../Kmz/functions/pagination';
import Swal from 'sweetalert2';
import { notify } from '../../common/functions/react-toastify.function.js';

const CreateRingRoute = (props) => {
  const {
    handleLockRoute,
    createRoutePopup,
    setAlternativeRoutes,
    setCreateRoutePopup,
    strArr,
    setMarkers,
    loadonMap,
    setMapMarkers,
    handleToggle,
    setIsToggled,
    alternativeRoutes,
    cancelAllRoutes,
    handleRemoveItem,
    strArray,
    markers,
    suggestions,
    handleSearch,
    routeSegments,
    selectedSegments,
    setRouteSegments,
    setSelectedSegments,
    showRingConnection,
    setShowRingConnection,
    showSegmentRouteSelection,
    clearAllRouteLayers,
    handleSegmentRouteSelection,
  } = props;
  const setRouteSelection = useSetAtom(routeSelection);
  const networkValue = useAtomValue(kmzNetwork);
  const noNetworkValue = useAtomValue(noNetwork);
  const [connectToNetwork, setConnectToNetwork] = useAtom(leasingPoints);
  const [systemOrOwnRoute, setSystemOrOwnRoute] = useState('system');
  const setOpen = useSetAtom(openRouteNamePopUp);
  const [routePath, setRoutePath] = useAtom(selectedRoutePath);
  const [currentPage, setCurrentPage] = useState(1);
  const routesPerPage = 10; // or whatever fits your UI
  const totalPages = alternativeRoutes?.length;
  const [hasShownNotification, setHasShownNotification] = useState(false);
  const handleCheckboxChange = (event) => {
    if (noNetworkValue) {
      Swal.fire({
        title: 'Enable My Network',
        text: `For using "Connect to Network" first enable my network`,
        icon: 'info',
      });
      return;
    }

    const checked = event.target.checked;
    setConnectToNetwork(checked);

    // Remove markers from the map
    markers.forEach((m) => m.marker.remove());
    setMarkers((prevMarkers) => {
      // Remove all markers from the map
      prevMarkers.forEach((m) => {
        if (m?.marker) {
          m.marker.remove();
        }
      });
      return []; // Clear markers array
    });

    setMapMarkers([]);

    setRoutePath(0);
    cancelAllRoutes();
    setSystemOrOwnRoute('system');
    setIsToggled(false);
    setMarkers([]);
  };

  useEffect(() => {
    if (noNetworkValue) {
      setConnectToNetwork(false);
    }
  }, [noNetworkValue]);
  useEffect(() => {
    setMarkers([]);
    strArr(['', '']);
    setAlternativeRoutes([]);
    setHasShownNotification(false); // Reset notification flag
  }, [connectToNetwork]);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    handleCancel();
  }, [networkValue]);
  const handleCancel = () => {
    setMarkers((prevMarkers) => {
      // Remove all markers from the map
      prevMarkers.forEach((m) => {
        if (m?.marker) {
          m.marker.remove();
        }
      });
      return []; // Clear markers array
    });

    setRouteSelection(false);
    setRoutePath(0);
    cancelAllRoutes();
    setSystemOrOwnRoute('system');
    setCreateRoutePopup(false);
    setIsToggled(false);
    setConnectToNetwork(false);

    // Clear route segments and selected segments
    if (setRouteSegments) {
      setRouteSegments({});
    }
    if (setSelectedSegments) {
      setSelectedSegments({});
    }
    if (setShowRingConnection) {
      setShowRingConnection(false);
    }

    // Clear all route layers from the map
    if (clearAllRouteLayers) {
      clearAllRouteLayers();
    }
  };
  const handleSystemOrOwnRoute = (path) => {
    if (systemOrOwnRoute === path) {
      return;
    }
    setSystemOrOwnRoute(path);
    handleToggle();
  };
  const handleLock = () => {
    setOpen(true);
  };

  const handleCloseCost = () => {
    setOpen(false);
  };

  return (
    <div
      style={{
        width: '100%',
        padding: 20,
        background: 'white',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.16)',
        borderRadius: 12,
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: 20,
        display: 'inline-flex',
      }}
    >
      <div
        style={{
          width: 418,
          justifyContent: 'space-between',
          alignItems: 'center',
          display: 'inline-flex',
        }}
      >
        <div
          style={{
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            color: 'var(--Text-Default-text-primary, rgba(0, 0, 0, 0.80))',
            fontSize: 16,
            fontFamily: 'Inter',
            fontWeight: '600',
            wordWrap: 'break-word',
          }}
        >
          Create Ring{' '}
        </div>

        {/* Ring Connection Checkbox */}

        {connectToNetwork ? null : (
          <div
            style={{
              height: 32,
              cursor: 'pointer',
              padding: 4,
              background: '#DDDEDE',
              borderRadius: 8,
              justifyContent: 'flex-start',
              alignItems: 'center',
              gap: 4,
              display: 'flex',
            }}
          >
            <div
              onClick={() => handleSystemOrOwnRoute('own')}
              style={{
                background: systemOrOwnRoute === 'own' ? 'var(--colors-common-white, white)' : null,
                height: 24,
                paddingLeft: 12,
                paddingRight: 12,
                paddingTop: 8,
                paddingBottom: 8,
                overflow: 'hidden',
                borderRadius: 6,
                justifyContent: 'center',
                alignItems: 'center',
                gap: 8,
                display: 'flex',
              }}
            >
              <div
                style={{
                  color: systemOrOwnRoute === 'own' ? '#192126' : 'rgba(0, 0, 0, 0.20)',
                  fontSize: 14,
                  fontFamily: 'Poppins',
                  fontWeight: '400',
                  wordWrap: 'break-word',
                }}
              >
                Own Route
              </div>
            </div>
            <div
              onClick={() => handleSystemOrOwnRoute('system')}
              style={{
                height: 24,
                paddingLeft: 12,
                paddingRight: 12,
                paddingTop: 8,
                paddingBottom: 8,
                background:
                  systemOrOwnRoute === 'system' ? 'var(--colors-common-white, white)' : null,
                overflow: 'hidden',
                borderRadius: 6,
                justifyContent: 'center',
                alignItems: 'center',
                gap: 8,
                display: 'flex',
              }}
            >
              <div
                style={{
                  color: systemOrOwnRoute === 'system' ? '#192126' : 'rgba(0, 0, 0, 0.20)',
                  fontSize: 14,
                  fontFamily: 'Poppins',
                  fontWeight: '500',
                  wordWrap: 'break-word',
                }}
              >
                System Route
              </div>
            </div>
          </div>
        )}
      </div>
      {markers.length > 2 && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <input
            type="checkbox"
            id="ringConnection"
            checked={showRingConnection}
            onChange={(e) => setShowRingConnection(e.target.checked)}
            style={{ cursor: 'pointer' }}
          />
          <label
            htmlFor="ringConnection"
            style={{
              fontSize: '12px',
              fontFamily: 'Poppins',
              color: '#656E7A',
              cursor: 'pointer',
            }}
          >
            Connect last to first
          </label>
        </div>
      )}
      <div style={{ width: '405px', overflowX: 'hidden', overflowY: 'scroll', maxHeight: '200px' }}>
        {markers.length < 3 ? (
          <>
            <div style={{ display: 'flex' }}>
              <div
                style={{
                  width: 16,
                  marginTop: '8%',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  gap: 6,
                  display: 'flex',
                }}
              >
                <div style={{ width: 20, height: 20, position: 'relative' }}>
                  <div style={{ width: 20, height: 20, left: 0, top: 0, position: 'absolute' }} />
                  <div
                    style={{
                      width: 5,
                      height: 5,
                      left: 7.5,
                      top: 7.5,
                      position: 'absolute',
                      borderRadius: 9999,
                      outline: '1.50px #3E4958 solid',
                      outlineOffset: '-0.75px',
                    }}
                  />
                  <div
                    style={{
                      width: 13.33,
                      height: 13.33,
                      left: 3.33,
                      top: 3.33,
                      position: 'absolute',
                      borderRadius: 9999,
                      outline: '1.50px #3E4958 solid',
                      outlineOffset: '-0.75px',
                    }}
                  />
                  <div
                    style={{
                      width: 0.83,
                      height: 1.67,
                      left: 9.58,
                      top: 1.67,
                      position: 'absolute',
                      outline: '1.50px #3E4958 solid',
                      outlineOffset: '-0.75px',
                    }}
                  />
                  <div
                    style={{
                      width: 0.83,
                      height: 1.67,
                      left: 9.58,
                      top: 16.67,
                      position: 'absolute',
                      outline: '1.50px #3E4958 solid',
                      outlineOffset: '-0.75px',
                    }}
                  />
                  <div
                    style={{
                      width: 1.67,
                      height: 0.83,
                      left: 16.67,
                      top: 9.58,
                      position: 'absolute',
                      outline: '1.50px #3E4958 solid',
                      outlineOffset: '-0.75px',
                    }}
                  />
                  <div
                    style={{
                      width: 1.67,
                      height: 0.83,
                      left: 1.67,
                      top: 9.58,
                      position: 'absolute',
                      outline: '1.50px #3E4958 solid',
                      outlineOffset: '-0.75px',
                    }}
                  />
                </div>
                {!connectToNetwork ? (
                  <div
                    style={{
                      width: 7,
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: 6,
                      display: 'flex',
                    }}
                  >
                    <div
                      style={{
                        width: 5,
                        height: 5,
                        position: 'relative',
                        background: 'rgba(62, 73, 88, 0.80)',
                        borderRadius: 100,
                      }}
                    />
                    <div
                      style={{
                        width: 5,
                        height: 5,
                        position: 'relative',
                        background: 'rgba(62, 73, 88, 0.80)',
                        borderRadius: 100,
                      }}
                    />
                    <div
                      style={{
                        width: 5,
                        height: 5,
                        position: 'relative',
                        background: 'rgba(62, 73, 88, 0.80)',
                        borderRadius: 100,
                      }}
                    />
                    <div
                      style={{
                        width: 5,
                        height: 5,
                        position: 'relative',
                        background: 'rgba(62, 73, 88, 0.80)',
                        borderRadius: 100,
                      }}
                    />
                  </div>
                ) : null}
              </div>

              <div
                style={{
                  width: 360,
                  marginLeft: '7px',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                  gap: 16,
                  display: 'flex',
                }}
              >
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: 4,
                    display: 'inline-flex',
                  }}
                >
                  <div
                    style={{
                      color: '#656E7A',
                      fontSize: 12,
                      fontFamily: 'Poppins',
                      fontWeight: '500',
                      wordWrap: 'break-word',
                    }}
                  >
                    Origin Marker
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', margin: '1%' }}>
                    <input
                      type="text"
                      value={
                        strArray[0] ||
                        (markers.length > 0 ? `${markers[0].lng},${markers[0].lat}` : '')
                      }
                      onChange={(e) => {
                        // Show notification only once when user tries to type in this field
                        if (!hasShownNotification) {
                          notify(
                            'info',
                            'Please place a marker on the map first to set the origin location. This field will be automatically populated with the selected coordinates.'
                          );
                          setHasShownNotification(true);
                        }
                        // Prevent typing by reverting to original value
                        e.target.value =
                          strArray[0] ||
                          (markers.length > 0 ? `${markers[0].lng},${markers[0].lat}` : '');
                      }}
                      style={{
                        padding: '2px',
                        borderRadius: '2px',
                        border: '1px #C8CCD2 solid',
                        width: '360px',
                        height: 36,
                        paddingLeft: '8px',
                        cursor: 'pointer',
                      }}
                      title="Click on the map to place a marker first"
                    />
                  </div>
                  {suggestions.length > 0 && (
                    <ul style={{ marginTop: '10px' }}>
                      {suggestions.map((suggestion, index) => (
                        <li
                          key={index}
                          style={{
                            padding: '5px',
                            cursor: 'pointer',
                            background: '#f0f0f0',
                            marginBottom: '5px',
                          }}
                          // onClick={() => handleSelectSuggestion(suggestion)}
                        >
                          {suggestion.place_name}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
            {!connectToNetwork ? (
              <div style={{ display: 'flex', marginTop: '-7%' }}>
                <div
                  style={{
                    width: 16,
                    marginTop: '8%',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    gap: 6,
                    display: 'flex',
                  }}
                >
                  <div style={{ width: 20, height: 20, position: 'relative' }}>
                    <div style={{ width: 20, height: 20, left: 0, top: 0, position: 'absolute' }} />
                    <div
                      style={{
                        width: 5,
                        height: 5,
                        left: 7.5,
                        top: 7.5,
                        position: 'absolute',
                        borderRadius: 9999,
                        outline: '1.50px #3E4958 solid',
                        outlineOffset: '-0.75px',
                      }}
                    />
                    <div
                      style={{
                        width: 13.33,
                        height: 13.33,
                        left: 3.33,
                        top: 3.33,
                        position: 'absolute',
                        borderRadius: 9999,
                        outline: '1.50px #3E4958 solid',
                        outlineOffset: '-0.75px',
                      }}
                    />
                    <div
                      style={{
                        width: 0.83,
                        height: 1.67,
                        left: 9.58,
                        top: 1.67,
                        position: 'absolute',
                        outline: '1.50px #3E4958 solid',
                        outlineOffset: '-0.75px',
                      }}
                    />
                    <div
                      style={{
                        width: 0.83,
                        height: 1.67,
                        left: 9.58,
                        top: 16.67,
                        position: 'absolute',
                        outline: '1.50px #3E4958 solid',
                        outlineOffset: '-0.75px',
                      }}
                    />
                    <div
                      style={{
                        width: 1.67,
                        height: 0.83,
                        left: 16.67,
                        top: 9.58,
                        position: 'absolute',
                        outline: '1.50px #3E4958 solid',
                        outlineOffset: '-0.75px',
                      }}
                    />
                    <div
                      style={{
                        width: 1.67,
                        height: 0.83,
                        left: 1.67,
                        top: 9.58,
                        position: 'absolute',
                        outline: '1.50px #3E4958 solid',
                        outlineOffset: '-0.75px',
                      }}
                    />
                  </div>
                </div>

                <div
                  style={{
                    width: 360,
                    marginLeft: '7px',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: 16,
                    display: 'flex',
                  }}
                >
                  <div
                    style={{
                      width: '100%',
                      height: '100%',
                      flexDirection: 'column',
                      justifyContent: 'flex-start',
                      alignItems: 'flex-start',
                      gap: 4,
                      display: 'inline-flex',
                    }}
                  >
                    <div
                      style={{
                        color: '#656E7A',
                        fontSize: 12,
                        fontFamily: 'Poppins',
                        fontWeight: '500',
                        wordWrap: 'break-word',
                      }}
                    >
                      Destination Marker
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', margin: '1%' }}>
                      <input
                        type="text"
                        value={markers.length > 1 ? `${markers[1].lng},${markers[1].lat}` : ''}
                        readOnly
                        style={{
                          padding: '2px',
                          borderRadius: '2px',
                          border: '1px solid #ccc',
                          width: '360px',
                          height: 36,
                          paddingLeft: '8px',
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </>
        ) : (
          markers.map((i, index) => (
            <>
              <div style={{ display: 'flex', marginTop: index != 0 ? '-28px' : null }}>
                <div
                  style={{
                    width: 16,
                    marginTop: '8%',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    gap: 6,
                    display: 'flex',
                  }}
                >
                  <div style={{ width: 20, height: 20, position: 'relative' }}>
                    <div style={{ width: 20, height: 20, left: 0, top: 0, position: 'absolute' }} />
                    <div
                      style={{
                        width: 5,
                        height: 5,
                        left: 7.5,
                        top: 7.5,
                        position: 'absolute',
                        borderRadius: 9999,
                        outline: '1.50px #3E4958 solid',
                        outlineOffset: '-0.75px',
                      }}
                    />
                    <div
                      style={{
                        width: 13.33,
                        height: 13.33,
                        left: 3.33,
                        top: 3.33,
                        position: 'absolute',
                        borderRadius: 9999,
                        outline: '1.50px #3E4958 solid',
                        outlineOffset: '-0.75px',
                      }}
                    />
                    <div
                      style={{
                        width: 0.83,
                        height: 1.67,
                        left: 9.58,
                        top: 1.67,
                        position: 'absolute',
                        outline: '1.50px #3E4958 solid',
                        outlineOffset: '-0.75px',
                      }}
                    />
                    <div
                      style={{
                        width: 0.83,
                        height: 1.67,
                        left: 9.58,
                        top: 16.67,
                        position: 'absolute',
                        outline: '1.50px #3E4958 solid',
                        outlineOffset: '-0.75px',
                      }}
                    />
                    <div
                      style={{
                        width: 1.67,
                        height: 0.83,
                        left: 16.67,
                        top: 9.58,
                        position: 'absolute',
                        outline: '1.50px #3E4958 solid',
                        outlineOffset: '-0.75px',
                      }}
                    />
                    <div
                      style={{
                        width: 1.67,
                        height: 0.83,
                        left: 1.67,
                        top: 9.58,
                        position: 'absolute',
                        outline: '1.50px #3E4958 solid',
                        outlineOffset: '-0.75px',
                      }}
                    />
                  </div>
                  {index != markers.length - 1 ? (
                    <div
                      style={{
                        width: 7,
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 6,
                        display: 'flex',
                      }}
                    >
                      <div
                        style={{
                          width: 5,
                          height: 5,
                          position: 'relative',
                          background: 'rgba(62, 73, 88, 0.80)',
                          borderRadius: 100,
                        }}
                      />
                      <div
                        style={{
                          width: 5,
                          height: 5,
                          position: 'relative',
                          background: 'rgba(62, 73, 88, 0.80)',
                          borderRadius: 100,
                        }}
                      />
                      <div
                        style={{
                          width: 5,
                          height: 5,
                          position: 'relative',
                          background: 'rgba(62, 73, 88, 0.80)',
                          borderRadius: 100,
                        }}
                      />
                      <div
                        style={{
                          width: 5,
                          height: 5,
                          position: 'relative',
                          background: 'rgba(62, 73, 88, 0.80)',
                          borderRadius: 100,
                        }}
                      />
                    </div>
                  ) : null}
                </div>

                <div
                  style={{
                    width: 360,
                    marginLeft: '7px',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: 16,
                    display: 'flex',
                  }}
                >
                  <div
                    style={{
                      width: '100%',
                      height: '100%',
                      flexDirection: 'column',
                      justifyContent: 'flex-start',
                      alignItems: 'flex-start',
                      gap: 4,
                      display: 'inline-flex',
                    }}
                  >
                    <div
                      style={{
                        color: '#656E7A',
                        fontSize: 12,
                        fontFamily: 'Poppins',
                        fontWeight: '500',
                        wordWrap: 'break-word',
                      }}
                    >
                      {index === 0
                        ? 'Origin Marker'
                        : index === markers.length - 1
                          ? 'Destination Marker'
                          : 'MileStones'}
                    </div>
                    <div
                      style={{
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        margin: '1%',
                      }}
                    >
                      <input
                        type="text"
                        value={strArray[index] || `${i.lng},${i.lat}`}
                        style={{
                          padding: '2px',
                          borderRadius: '2px',
                          border: '1px #C8CCD2 solid',
                          width: '360px',
                          height: 36,
                          paddingLeft: '8px',
                        }}
                      />
                      <button
                        onClick={() => handleRemoveItem(index)}
                        style={{
                          position: 'absolute',
                          right: '8px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          background: 'transparent',
                          border: 'none',
                          cursor: 'pointer',
                          fontSize: '16px',
                          padding: 0,
                          lineHeight: 1,
                          color: '#999',
                        }}
                      >
                        <strong>X</strong>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ))
        )}
      </div>

      {/* Route Segments Selection */}
      {Object.keys(routeSegments).length > 0 && (
        <div style={{ width: '100%' }}>
          <div
            style={{
              color: '#656E7A',
              fontSize: 14,
              fontFamily: 'Poppins',
              fontWeight: '500',
              marginBottom: '10px',
            }}
          >
            Route Segments
          </div>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '8px 12px',
              alignItems: 'start',
              maxHeight: '160px',
              overflowY: 'auto',
              paddingRight: '4px',
              scrollbarWidth: 'thin',
              scrollbarColor: '#C8CCD2 #f5f5f5',
            }}
          >
            {Object.keys(routeSegments).map((segmentIndex, index) => {
              const segmentRoutes = routeSegments[segmentIndex];
              const selectedRoute = selectedSegments[segmentIndex];
              const segmentNum = parseInt(segmentIndex);
              const isLastToFirst = segmentNum === markers.length - 1;

              return (
                <div
                  key={segmentIndex}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px',
                    width: '100%',
                  }}
                >
                  {/* Segment Label */}
                  <div style={{ fontSize: '10px', fontWeight: '500', color: '#333' }}>
                    Seg {segmentNum + 1} → {isLastToFirst ? '1' : segmentNum + 2}
                    {isLastToFirst && ' (R)'}
                  </div>

                  {/* Route Options Row */}
                  <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                    {segmentRoutes.map((route, routeIndex) => {
                      const isSelected = selectedRoute && selectedRoute === route;
                      return (
                        <div
                          key={routeIndex}
                          onClick={() => {
                            // Handle route selection directly without popup
                            if (handleSegmentRouteSelection) {
                              handleSegmentRouteSelection(segmentIndex, route);
                            }
                          }}
                          style={{
                            padding: '4px 8px',
                            border: isSelected ? '2px solid #007bff' : '1px solid #E5E9EB',
                            borderRadius: '4px',
                            backgroundColor: isSelected ? '#f0f8ff' : '#f9f9f9',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            minWidth: '40px',
                            justifyContent: 'center',
                            transition: 'all 0.2s ease',
                          }}
                        >
                          <div
                            style={{
                              width: '8px',
                              height: '2px',
                              backgroundColor: route.color,
                              borderRadius: '1px',
                            }}
                          />
                          <span
                            style={{
                              fontSize: '10px',
                              fontWeight: isSelected ? '600' : '400',
                              color: isSelected ? '#007bff' : '#333',
                            }}
                          >
                            {routeIndex + 1}
                          </span>
                        </div>
                      );
                    })}
                  </div>

                  {/* Selected Route Info */}
                  {/* {selectedRoute && (
                    <div
                      style={{
                        fontSize: '10px',
                        color: '#666',
                        padding: '4px 8px',
                        backgroundColor: '#f5f5f5',
                        borderRadius: '4px',
                        marginTop: '4px',
                      }}
                    >
                      {selectedRoute.profile} • {Math.round(selectedRoute.duration / 60)} min •{' '}
                      {(selectedRoute.distance / 1000).toFixed(1)} km
                    </div>
                  )} */}
                </div>
              );
            })}
          </div>
        </div>
      )}

      <div
        style={{
          width: 414,
          height: 0,
          outline: '1px var(--Gray-300, #D1D5DB) solid',
          outlineOffset: '-0.50px',
        }}
      ></div>
      <div
        style={{
          width: 418,
          justifyContent: 'space-between',
          alignItems: 'center',
          display: 'inline-flex',
        }}
      >
        <div
          data-property-1="Active"
          style={{
            height: 32,
            paddingLeft: 12,
            paddingRight: 12,
            paddingTop: 6,
            paddingBottom: 6,
            background: 'white',
            boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
            overflow: 'hidden',
            borderRadius: 4,
            outline: '1px #D9D9D9 solid',
            outlineOffset: '-0.50px',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
          }}
        >
          <div style={{ justifyContent: 'center', alignItems: 'center', gap: 10, display: 'flex' }}>
            <div
              onClick={() => handleCancel()}
              style={{
                cursor: 'pointer',
                color: '#2B323B',
                fontSize: 14,
                fontFamily: 'Poppins',
                fontWeight: '500',
                wordWrap: 'break-word',
              }}
            >
              Cancel
            </div>
          </div>
        </div>
        {markers.length >= 3 && Object.keys(selectedSegments).length > 0 ? (
          <div
            style={{ justifyContent: 'flex-start', alignItems: 'center', gap: 8, display: 'flex' }}
          >
            <div
              onClick={() => handleLock()}
              data-property-1="Active"
              style={{
                height: 32,
                cursor: 'pointer',
                paddingLeft: 12,
                paddingRight: 12,
                paddingTop: 6,
                paddingBottom: 6,
                background: '#BD1D23',
                boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                overflow: 'hidden',
                borderRadius: 4,
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
              }}
            >
              <div
                style={{
                  paddingLeft: 8,
                  paddingRight: 8,
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: 10,
                  display: 'flex',
                }}
              >
                <div
                  style={{
                    color: 'white',
                    fontSize: 14,
                    fontFamily: 'Poppins',
                    fontWeight: '500',
                    wordWrap: 'break-word',
                  }}
                >
                  Lock Ring
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CreateRingRoute;
